<template>
    <div class="info-bathymetry-container">
        <div class="global-bathymetry-container">
          <div class="filter-global-container">
            <div class="panel-content-line">
                <input type="checkbox" id="global-bathymetry-checkbox" name="global-bathymetry-checkbox" v-model="bathymetryGlobal">
                <label for="global-bathymetry-checkbox">Batimetría global</label>
            </div>
            <div class="panel-content-line">
                <input type="checkbox" id="campaigns-bathymetry-checkbox" name="campaigns-bathymetry-checkbox" v-model="bathymetryCampaigns">
                <label for="campaigns-bathymetry-checkbox">Batimetrías por campaña</label>
            </div>
          </div>
          <form :model="form" ref="form" v-on:submit.prevent v-if="bathymetryCampaigns">
            <div class="filter-date-container">
              <div class="panel-content-line filter-element">
                  <label for="bathymetry-start-date">Fecha inicio</label>
                  <br>
                  <input type="date" id="bathymetry-start-date" name="bathymetry-start-date" class="custom-input-text" v-model="form.bathymetryStartDate">
              </div>
              <div class="panel-content-line filter-element">
                  <label for="bathymetry-start-date">Fecha fin</label>
                  <br>
                  <input type="date" id="bathymetry-end-date" name="bathymetry-end-date" class="custom-input-text" v-model="form.bathymetryEndDate">
              </div>
            </div>
            <div class="panel-content-line filter-element">
              <label for="campaign-filter">Búsqueda de campañas</label>
              <br>
              <input type="text" id="campaign-filter" name="campaign-filter" class="custom-input-text" v-model="form.campaignFilter">
            </div>
            <br>
            <button class="btn-new ml-auto" v-on:click="getFilteredBathymetry">Filtrar</button>
          </form>
        </div>
    </div>
</template>

<script>
  import {getData} from './../../services/api'

  export default {
    name: 'filterPanelBathymetry',
    data() {
        return {
          form: {
            bathymetryStartDate: '',
            bathymetryEndDate: '',
            campaignFilter: ''
          }
        }
    },
    computed: {
      bathymetryGlobal: {
          set () { this.$store.dispatch('changeBathymetryGlobalOrCampaigns', {globalOrCampaigns: 'global'}); },
          get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryGlobal }
      },
      bathymetryCampaigns: {
          set () { this.$store.dispatch('changeBathymetryGlobalOrCampaigns', {globalOrCampaigns: 'campaigns'}); },
          get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryCampaigns }
      },
      bathymetryCampaignsList: {
          set (campaignsList) { this.$store.dispatch('changeBathymetryCampaignsList', {bathymetryCampaignsList: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryCampaignsList }
      },
      bathymetryCampaignsListFiltered: {
          set (campaignsList) { this.$store.dispatch('changeBathymetryCampaignsListFiltered', {bathymetryCampaignsListFiltered: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerBathymetry.bathymetryCampaignsListFiltered }
      }
    },
    beforeMount () {
        this.getBathymetryData()
    },
    methods: {
      getBathymetryData: function () {
          var url = 'mmdata/bathymetry-campaigns/'
          getData(url).then(res=> {
              this.bathymetryCampaignsList = res.data.bathymetryCampaigns
              this.bathymetryCampaignsListFiltered = res.data.bathymetryCampaigns
          })
      },
      getFilteredBathymetry: function () {
        var start = '2000-01-01'
        var end = 'now'
        var campFilter = 'no filter'
        if(this.form.bathymetryStartDate != '') start = this.form.bathymetryStartDate
        if(this.form.bathymetryEndDate != '') end = this.form.bathymetryEndDate
        if(this.form.campaignFilter != '') campFilter = this.form.campaignFilter
        var url = 'mmdata/bathymetry-campaigns-filtered/' + start + '/' + end + '/' + campFilter + '/'

        getData(url).then(res=> {
          this.bathymetryCampaignsListFiltered = res.data.bathymetryCampaigns
        })
        .catch(error => {
          this.$noty.error("Error")
        })
      }
    }
  }
</script>

<style scoped>
  .info-bathymetry-container {
    width: 100%;
    padding: 0px 10px 10px 18px;
  }
  .global-bathymetry-container {
    display: flex;
    flex-direction: column;
  }
  .panel-content-line{
    font-size: small;
    line-height: 80%;
  }
  .filter-date-container {
    display: flex;
    flex-direction: row;
    margin-bottom: 1em;
    padding-bottom: 1rem;
    border-bottom: solid 1px lightgrey;
  }
  .filter-global-container {
    margin-bottom: 1em;
    padding-bottom: 1rem;
    border-bottom: solid 1px lightgrey;
  }
  .filter-element {
    flex: 1;
    margin: 0.3rem;
  }
  .custom-input-text{
    background-color: #f9f9f9;
    font-size: 12px;
    width: 100%;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: .375rem 1.75rem .375rem .75rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/FilterPanelBathymetry.vue